/** Shared localStorage cache for delayed sidebar watchlist quotes (not user-specific). */

const VERSION = 1;
const KEY = `risklo-sidebar-quotes.v${VERSION}`;

export function readSidebarQuotesCache() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      stocks: parsed.stocks && typeof parsed.stocks === 'object' ? parsed.stocks : {},
      world: parsed.world && typeof parsed.world === 'object' ? parsed.world : {},
      benchmarks: parsed.benchmarks && typeof parsed.benchmarks === 'object' ? parsed.benchmarks : {},
      ts: Number(parsed.ts) || 0,
    };
  } catch (_err) {
    return null;
  }
}

export function writeSidebarQuotesCache({ stocks, world, benchmarks }) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify({
      stocks: stocks || {},
      world: world || {},
      benchmarks: benchmarks || {},
      ts: Date.now(),
    }));
  } catch (_err) {
    /* non-fatal */
  }
}
